export default __webpack_public_path__ + "static/media/meeting-res-btn.c7cf2f5c.svg";